import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function Contact() {
  return (
    <div className="min-vh-content">
      <section className="page-section contact-section">
        <Container>
          <h1 className="section-title text-center">Contact Us</h1>
          <p className="section-subtitle">
            Reach out for partnership enquiries, fixtures, and community activities. We aim to respond within 48 hours.
          </p>

          <Row className="align-items-stretch">
            <Col md={12} lg={6} className="mb-4">
              <Card className="mb-4 contact-side-card brand-card">
                <Card.Body>
                  <Card.Title className="h5 mb-3">Contact Information</Card.Title>
                  <Card.Text>
                    <strong>Email:</strong><br />
                    <a href="mailto:chhetrimessi1011@gmail.com">Thunderdragonfootballclub@gmail.com</a>
                  </Card.Text>
                  <Card.Text>
                    <strong>Phone:</strong><br />
                    <a href="tel:+61403732692">0403 732 692</a>
                  </Card.Text>
                  <Card.Text>
                    <strong>Address:</strong><br />
                    Melbourne, Victoria<br />
                    Australia
                  </Card.Text>
                </Card.Body>
              </Card>

              <Card className="contact-side-card brand-card">
                <Card.Body>
                  <Card.Title className="h5 mb-3">Training Schedule</Card.Title>
                  <Card.Text>
                    <strong>Practice Days:</strong><br />
                    Thursday & Saturday<br />
                    5:30 PM - 8:00 PM
                  </Card.Text>
                  <Card.Text>
                    <strong>Location:</strong><br />
                    217 Camp Rd, Broadmeadows VIC 3047<br />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={12} lg={6}>
              <Card className="contact-side-card brand-card">
                <Card.Body>
                  <Card.Title className="h5 mb-3">Follow Us</Card.Title>
                  <Card.Text>
                    Stay connected with Thunder Dragon FC on social media:
                  </Card.Text>
                  <div className="d-flex flex-column">
                    <a href="https://www.facebook.com/Thunderdragonfc/" className="mb-2">Facebook</a>
                    <a href="https://www.instagram.com/thunderdragonfc/" className="mb-2">Instagram</a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Contact;
